export default __webpack_public_path__ + "static/p3-ed6738d815e6ed8e6831d486c10be8ef.png";